enum LoginProvider {
	NONE = 0,
	FB = 1,
	GGL = 2,
}

export { LoginProvider }
